import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import styles from "./Profile.module.css";
import { customTextColor } from "../../utils/const";
import ProfileBanner from "./ProfileBanner";
import { PiUserLight } from "react-icons/pi";
import { BsGenderAmbiguous } from "react-icons/bs";
import { CiMobile3 } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { CiLinkedin } from "react-icons/ci";
import { PiAddressBookLight } from "react-icons/pi";
import { PiChairLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { PiIdentificationCardLight } from "react-icons/pi";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoIosArrowRoundBack } from "react-icons/io";
import { getAllBranch, getProfile } from "../../redux/profile/profileSlice";
import ProfileUpdateDrawer from "./ProfileUpdateDrawer";
import { Icon } from "@iconify/react/dist/iconify.js";
import { TfiWorld } from "react-icons/tfi";

const ProfileViewDrawer = ({ handleClose, show }) => {
  const [userDetails, setUserdetails] = useState({});
  const [banner, setBanner] = useState(null);
  const [profile_image, setProfile_image] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);
  const profileLoading = useSelector((state) => state.profile.status);
  const branchData = useSelector((state) => state.profile?.branchData);
  const [showViewProfile, setShowViewProfile] = useState(false);
  const handleCloseShowViewProfile = () => setShowViewProfile(false);
  const handleShowViewProfile = () => setShowViewProfile(true);

  useEffect(() => {
    if (profile) {
      setUserdetails(profile?.data?.profile);
      setBanner(profile?.data?.profile?.banner_picture);
      setProfile_image(profile?.data?.profile?.profile_picture);
    }
  }, [profile]);

  useEffect(() => {
    dispatch(getProfile());
    dispatch(getAllBranch());
  }, [dispatch]);

  console.log({ branchData });

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "60%",
        // padding: "0 0 0 10px",
        backgroundColor: "#fafafa",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "end",
        }}
      >
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
            marginRight: "20px",
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        <Box>
          <ProfileBanner banner={banner} profile_image={profile_image} />
          {profileLoading === "loading" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 230,
              }}
            >
              <CircularProgress size={30} color="info" />
            </Box>
          ) : (
            <Grid
              container
              className={styles.profile_details_view}
              sx={{ color: customTextColor }}
            >
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <span>
                  <Box>
                    <PiIdentificationCardLight
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography>
                      <b>{userDetails?.username}</b>
                    </Typography>
                  </Box>

                  <Box>
                    <BsGenderAmbiguous
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography>
                      <b>{userDetails?.gender}</b>
                    </Typography>
                  </Box>

                  <Box>
                    <PiMailboxLight
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography>
                      <b>{userDetails?.email}</b>
                    </Typography>
                  </Box>

                  <Box>
                    <PiAddressBookLight
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography>
                      <b>
                        {userDetails?.experience}{" "}
                        {userDetails?.experience > 1 ? "Years" : "Year"}
                      </b>
                    </Typography>
                  </Box>

                  {/* <Box>
                    <Icon
                      icon="fluent:building-people-20-regular"
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography>
                      <b>
                        {userDetails?.company_branch !== undefined &&
                          userDetails?.company_branch[0]?.company_location}
                      </b>
                    </Typography>
                  </Box> */}

                  <Box>
                    <TfiWorld
                      style={{ fontSize: "21px", color: customTextColor }}
                    />
                    <Typography>
                      <b>{userDetails?.company_website}</b>
                    </Typography>
                  </Box>
                </span>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <span>
                  <Box>
                    <PiUserLight
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography>
                      <b>{userDetails?.full_name}</b>
                    </Typography>
                  </Box>

                  <Box>
                    <CiMobile3
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography>
                      <b>{userDetails?.mobile_no}</b>
                    </Typography>
                  </Box>

                  <Box>
                    <PiChairLight
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography>
                      <b>{userDetails?.designation}</b>
                    </Typography>
                  </Box>

                  <Box>
                    <PiBuildingOfficeLight
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography>
                      <b>{userDetails?.company_name}</b>
                    </Typography>
                  </Box>

                  {/* <Box>
                    <Icon
                      icon="ph:buildings-light"
                      style={{ fontSize: "25px", color: customTextColor }}
                    />

                    <Typography>
                      <b>
                        {userDetails?.company_branch !== undefined &&
                          userDetails?.company_branch[0]?.branch_name}
                      </b>
                    </Typography>
                  </Box> */}

                  <Box>
                    <CiLinkedin
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography>
                      <b>{userDetails?.linkedin_profile_url}</b>
                    </Typography>
                  </Box>
                </span>
              </Grid>
            </Grid>
          )}
          {userDetails?.company_branch?.map((branch) => {
            return (
              <Box className={styles.BranchCard}>
                <span>
                  <Typography>
                    <b>{branch?.division}</b>
                  </Typography>
                  <Typography>
                    <b>
                      {branch?.plot_number}, {branch?.landmark} {branch?.state}{" "}
                      {branch?.pincode}
                    </b>
                  </Typography>
                  <Typography sx={{ marginTop: "7px" }}>
                    Created by{" "}
                    {branch?.created_by_details !== null &&
                      branch?.created_by_details !== undefined &&
                      branch?.created_by_details?.profiles[0]?.fullName}{" "}
                  </Typography>
                </span>

                <span>
                  <button
                    style={{
                      padding: "8px 25px",
                      backgroundColor: "#3856a6",
                      color: "white",
                      border: "none",
                      cursor: "auto",
                    }}
                    className={styles.BranchCard_button}
                  >
                    Work In
                  </button>
                </span>
              </Box>
            );
          })}

          {profileLoading !== "loading" && (
            <Box className={styles.profile_edit_btns}>
              <button
                onClick={handleClose}
                style={{
                  border: "1.5px solid #4285f4",
                  marginRight: "10px",
                  padding: "4.5px 10px ",
                }}
              >
                <IoIosArrowRoundBack
                  style={{ fontSize: "25px", color: "#fff" }}
                />
              </button>
              <button onClick={handleShowViewProfile}>Update Profile</button>
            </Box>
          )}
        </Box>
      </Offcanvas.Body>

      <ProfileUpdateDrawer
        handleShow={handleShowViewProfile}
        handleClose={handleCloseShowViewProfile}
        show={showViewProfile}
        type="profile"
        userDetails={userDetails}
      />
    </Offcanvas>
  );
};

export default ProfileViewDrawer;
